export { default } from './HeaderLangSwitcher'
